import { createContext, useContext } from "react";

export const SocketContext = createContext({
  socket: null,
  isConnected: false,
  notifications: [],
  setNotifications: () => {},
});

export function useSocket() {
  return useContext(SocketContext);
}
